// for node.js
const DrcsDecoder = {
  draw: function(width, height, depth, type, pattern, color, isOrn) {

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    //ctx.fillStyle = "rgba(0,0,0,0)";
    //ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = color;

    let data = atob(pattern);
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        if (this._getPixelData(data, width, height, depth, x, y) === '3'){
          ctx.fillRect(x, y, 1, 1);
        }
      }
    }
    if (!isOrn) { return canvas; }

    ctx.fillStyle = 'rgba(0, 0, 0, 255)';
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        if (this._getPixelData(data, width, height, depth, x, y) !== '3'){
          for (let dy = -1; dy <= 1; dy++) {
            for (let dx = -1; dx <= 1; dx++) {
              if (dy === 0 && dx === 0) { continue; }
              if (y + dy < 0 || y + dy >= height || x + dx < 0 || x + dx >= width) { continue; }
              if (this._getPixelData(data, width, height, depth, x + dx, y + dy) === '3'){
                ctx.fillRect(x, y, 1, 1); break;
              }
            }
          }
        }
      }
    }

    return canvas;
  },

  decode: function(width, height, depth, type, pattern) {
    const rowBytes = width * depth / 8;
    //let data = this._decodeBase64(pattern); // for node.js
    let data = atob(pattern);
    for (let y = 0; y < height; y++) {
      let row = '';
      for (let x = 0; x < rowBytes; x++) {
        const i = y * rowBytes + x;
        row += this._zeroPadding(data.charCodeAt(i).toString(2));
      }
      console.log(row);
    }
  },
  // for node.js
  // _decodeBase64: function(str) {
  //   return new Buffer(str, 'base64').toString('binary');
  // },

  _getPixelData: function(data, width, height, depth, x, y) {
    const byteIndex = Math.floor((y * width + x) * depth / 8);
    const bitString = this._zeroPadding(data.charCodeAt(byteIndex).toString(8 / depth));
    return bitString[(y * width + x) % (8 / depth)];
  },
  _zeroPadding: function(num) {
    return ('0000' + parseInt(num, 10)).slice(-4);
  }
};

// for test
// const pattern = 'AAAAAAAAAAAAAAAAAAAAAAAAAAAPAAAAAAAAAAAPAAAAAAAAAADw8ADwAA8AAADw8ADwAA8AAA8ADwDwAA8AAA8ADwDwAA8AAPD/8AAPAPAAAPD/8AAPAPAADwAAAA////8ADwAAAA////8AAP///wAPAPAAAP///wAPAPAAAPAADwAPAPAAAPAADwAPAPAAAP///wAPAPAAAP///wAPAPAAAPAADwAPAPAAAPAADwAPAPAAAP///w/////wAP///w/////wAPAAAAAPAPAAAPAAAAAPAPAAAPAAAAAPAPAAAPAAAAAPAPAAAP///wAPAPAAAP///wAPAPAAAPAAAADwAPAAAPAAAADwAPAAAPAAAADwAPAAAPAAAADwAPAAAP///w8AAPAAAP///w8AAPAAAAAAAAAAAAAAAAAAAAAAAAAA';
// const width = 36;
// const height = 36;
// const depth = 2;
// const type = 1;
// DrcsDecoder.decode(width, height, depth, type, pattern);

export default DrcsDecoder;



// WEBPACK FOOTER //
// ./src/hlsjs/drcs-decoder.js